import { EVENTS } from '@/lib/consts.js'

export const gtm1Payments = {
  eventBusinessPaymentsActionHandler ({ data }) {
    const {
      screenName,
      eventAction,
      paymentFeature,
      entrancePath,
      kycStatus,
      chargesEnabled,
      payoutsEnabled,
      splashVariant,
      featureName,
      feeSettingSelected,
    } = data

    return {
      event: 'Business_Payments_Action',
      properties: {
        screen_name: screenName,
        event_action: eventAction,
        payment_feature: paymentFeature,
        entrance_path: entrancePath,
        kyc_status: kycStatus,
        charges_enabled: chargesEnabled,
        payouts_enabled: payoutsEnabled,
        splash_variant: splashVariant,
        feature_name: featureName,
        fee_setting_selected: feeSettingSelected,
      },
    }
  },

  [EVENTS.BOOKSY_WALLET_ACTION] ({ data }) {
    return {
      event: EVENTS.BOOKSY_WALLET_ACTION,
      properties: { ...data },
    }
  },

  [EVENTS.REFUND_ACTION] ({ data }) {
    return {
      event: EVENTS.REFUND_ACTION,
      properties: { ...data },
    }
  },

  [EVENTS.BOOKSY_PAY_ENABLED] ({ data }) {
    const { entrancePath } = data
    return {
      event: EVENTS.BOOKSY_PAY_ENABLED,
      properties: {
        entrance_path: entrancePath,
      },
    }
  },
}
